import React from 'react';
import { StaticPage } from '../StaticPage';

export const HelpPage: React.FC = () => (
  <StaticPage titleKey="static.help">
    <h2>Erste Schritte</h2>
    <ol>
      <li><strong>Steckbrief erstellen</strong> – Beschreibe die Person und die Situation so genau wie möglich.</li>
      <li><strong>Ort & Zeit angeben</strong> – Nutze die Karte und das Datumsfeld, um die Begegnung einzugrenzen.</li>
      <li><strong>Schlagworte nutzen</strong> – Tags helfen anderen, deinen Steckbrief zu finden.</li>
      <li><strong>Steckbriefstyp wählen</strong> – Verpasste Begegnung, Kennenlernen, Danke sagen …</li>
    </ol>

    <h2>Suche & Filter</h2>
    <p>
      Klicke auf <strong>„Steckbriefe durchsuchen"</strong>, um die Suchmaske zu öffnen.
      Du kannst nach Text, Ort, Zeitraum, Typ und Schlagworten filtern.
    </p>

    <h2>Nachrichten</h2>
    <p>
      Wenn du eingeloggt bist, kannst du anderen Nutzern direkt eine Nachricht schreiben.
      Deine Unterhaltungen findest du im Menü unter <strong>Nachrichten</strong>.
    </p>

    <h2>Profil & Einstellungen</h2>
    <p>
      In deinem Profil kannst du dein Bild, deinen Nutzernamen und deine Einstellungen verwalten.
    </p>

    <h2>Probleme?</h2>
    <p>
      Schreib uns eine E-Mail an{' '}
      <a href="mailto:contact@ithinkitsyou.com">contact@ithinkitsyou.com</a>.
    </p>
  </StaticPage>
);
